const SCRIPT_ID = "faciliti-tag"
const SCRIPT_URL = "https://ws.facil-iti.com/tag/faciliti-tag.min.js"
const USER_ID = "a79fc29e-9203-11eb-bb13-0abd40aed1a0"

export function initializeFaciliti() {
  globalThis.FACIL_ITI ||= {
    conf() {
      this.data ||= []
      this.data.push(arguments)
    }
  }
  globalThis.FACIL_ITI.conf("userId", USER_ID)

  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement("script")
  script.id = SCRIPT_ID
  script.async = true
  script.src = SCRIPT_URL
  document.head.append(script)
}
